// extracted by mini-css-extract-plugin
module.exports = {"button":"GButton_button_3K_jH"};